import validator from "validator";

const validationRules = [
  {
    field: "username",
    method: validator.isEmpty,
    validWhen: false,
    message: "Username tidak boleh kosong.."
  },
  {
    field: "username",
    method: validator.isAlphanumeric,
    args: ["en-US"],
    validWhen: true,
    message: "Username tidak boleh menggunakan tanda/simbol.."
  },
  {
    field: "password",
    method: validator.isEmpty,
    validWhen: false,
    message: "Password tidak boleh kosong.."
  },
  {
    field: "captcha",
    method: validator.isEmpty,
    validWhen: false,
    message: "Captcha tidak boleh kosong.."
  }
];

export default validationRules;
